import { Link } from 'react-router-dom';

interface GameCardProps {
  slug: string;
  name: string;
  categoryName: string;
  rating: number;
  players: number;
  tags: string[];
  image: string;
  isNew?: boolean;
}

export default function GameCard({ slug, name, categoryName, rating, players, tags, image, isNew }: GameCardProps) {
  const formatPlayers = (num: number) => {
    if (num >= 10000) return `${(num / 10000).toFixed(1)}万`;
    return num.toString();
  };

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={name}
          title={`${name} - PG游戏`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
            新游
          </span>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="text-white text-xs font-medium bg-black/40 px-2 py-0.5 rounded-md whitespace-nowrap">
            {categoryName}
          </span>
          <span className="text-primary-300 text-xs font-medium flex items-center gap-1">
            <i className="ri-star-fill text-xs"></i>
            {rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1.5 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
          {name}
        </h3>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs text-foreground-500">
            <i className="ri-user-line mr-0.5"></i>
            {formatPlayers(players)}人在玩
          </span>
        </div>
        <div className="flex flex-wrap gap-1">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}